export default __webpack_public_path__ + "static/media/ua.f23ed5bf.svg";